export const VossProductGroupType = {
    Optional: 0,
    Included: 1
}

export const VossProductGroupTypeText = {
    [VossProductGroupType.Optional]: "vossProductGroupType.optional",
    [VossProductGroupType.Included]: "vossProductGroupType.included"
}